import React from 'react';

const Footer = () => {
  return (
    <footer 
      className="fixed bottom-0 left-0 right-0 h-8 flex items-center justify-end px-6 z-40"
      style={{
        background: 'rgba(11, 19, 43, 0.95)',
        borderTop: '1px solid rgba(58, 134, 255, 0.15)',
        backdropFilter: 'blur(8px)'
      }}
    >
      <span className="text-xs text-white/40 font-light tracking-wide">
        By <span className="font-medium text-[#00D4FF]/70">Mbat</span>
      </span>
    </footer>
  );
};

export default Footer;
